import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {MotiDialogBoxButton} from '../../models/dialog-box';
import {NgClass} from '@angular/common';


@Component({
  selector: 'moti-empty-section-placeholder',
  templateUrl: './empty-section-placeholder.component.html',
  styleUrls: ['./empty-section-placeholder.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    NgClass,
  ],
})
export class EmptySectionPlaceholderComponent {
  @Input() faIconName: string;
  @Input() htmlText: string;
  @Input() buttons: MotiDialogBoxButton;
}
